import React from 'react';
import { Sparkles, Heart, Instagram, Twitter } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-white/50 backdrop-blur-md border-t border-pink-100 py-10 mt-20" data-id="element-33">
      <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-34">
        <div className="flex items-center gap-2 mb-4" data-id="element-35">
          <span className="font-pacifico text-3xl text-gradient-pink" data-id="element-36">
            SnapMory
          </span>
          <Sparkles className="w-5 h-5 text-pink-400" data-id="element-37" />
        </div>

        <p className="font-quicksand text-pink-800 font-medium mb-6 flex items-center gap-2" data-id="element-38">
          Made with love & pink vibes{' '}
          <Heart className="w-4 h-4 fill-pink-500 text-pink-500" data-id="element-39" />
        </p>

        <div className="flex gap-4" data-id="element-40">
          <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full bg-pink-100 flex items-center justify-center text-pink-600 hover:bg-pink-200 hover:scale-110 transition-all" data-id="element-41">
            <Instagram className="w-5 h-5" data-id="element-42" />
          </a>
          <a href="#" aria-label="Twitter" className="w-10 h-10 rounded-full bg-pink-100 flex items-center justify-center text-pink-600 hover:bg-pink-200 hover:scale-110 transition-all" data-id="element-43">
            <Twitter className="w-5 h-5" data-id="element-44" />
          </a>
        </div>

        <p className="mt-8 text-sm text-pink-600/70 font-quicksand" data-id="element-45">
          © {new Date().getFullYear()} SnapMory. 100% Free Online Photobooth.
        </p>
      </div>
    </footer>;
};